import React, { useState } from 'react'
import { InfoCircle } from 'react-bootstrap-icons'

import './Card.scss'
import { FolderFilled } from '@ant-design/icons'

export interface FolderCardProps {
  label: string
  path: string
  description: string
  onClicked?: (card: FolderCardProps) => any
}

export const FolderCard: React.FC<FolderCardProps> = ({
  label,
  path,
  description,
  onClicked,
}) => {

  const [open, setOpen] = useState<boolean>(false)
  const [over, setOver] = useState(false)

  return <div className='card-param card-folder'
    tabIndex={0}
    role='button'
    key={label}
    onClick={(event) => {
      event.stopPropagation()
      onClicked({ label, path, description })
      }}>
    <div className='title-param'>
      <div style={{ float: 'left', margin: '0 8px 0 0' }}>
        <span style={{ margin: '0 8px 0 0' }}>
          <FolderFilled style={{ fontSize: '20px'}} />
        </span>
        {label}
      </div>
      <div style={{ textAlign: 'right' }}>
        <button style={{ all: 'unset', margin: '0 0 0 8px' }}
          onMouseOver={() => setOver(true)}
          onMouseLeave={() => setOver(false)}
          onClick={(event) => {
            event.stopPropagation()
            setOpen(prev => !prev)
          }}>
          <InfoCircle size={14} style={over ? { color: '#40a9ff' } : {}}/>
        </button>
      </div>
    </div>
    {open && <div className='card-description'>{description}</div>}
  </div>
}

export default FolderCard

